// extracted by mini-css-extract-plugin
export default {"value":"pPaSUsXzvvDys813tbbuVA==","currency":"OTcE-BlezWwynAA9S4L2vg=="};